import { createContext } from "react";

const NotificationContext = createContext<null | VoidFunction>(null);

export { NotificationContext };
